(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-screenshots"] && !Shopify.designMode) return;
  try {
    
function cshotInit(scope){
  (scope || document).querySelectorAll('.cshot').forEach(function(root){
    if(root.dataset.cshotInit) return;
    root.dataset.cshotInit = '1';
    var lb = root.querySelector('.cshot-lightbox');
    if(!lb) return;
    var img = lb.querySelector('.cshot-lightbox__img');
    var closeBtn = lb.querySelector('.cshot-lightbox__close');
    var lastFocus = null;

    function open(src, alt){
      img.src = src;
      if(alt) img.alt = alt;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      lastFocus = document.activeElement;
      closeBtn.focus();
    }
    function close(){
      lb.hidden = true;
      img.src = '';
      document.documentElement.style.overflow = '';
      if(lastFocus) lastFocus.focus();
    }

    root.querySelectorAll('.cshot-zoom').forEach(function(btn){
      btn.addEventListener('click', function(){
        var thumb = btn.querySelector('img');
        open(btn.getAttribute('data-full'), thumb ? thumb.alt : '');
      });
    });
    closeBtn.addEventListener('click', close);
    lb.addEventListener('click', function(e){ if(e.target === lb) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !lb.hidden) close(); });
  });
}
cshotInit(document);
document.addEventListener('shopify:section:load', function(e){ cshotInit(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
function cmlInitReviews(scope){
  (scope || document).querySelectorAll('.cml').forEach(function(root){
    if(root.dataset.cmlInit) return;
    root.dataset.cmlInit = '1';
    var feed = root.querySelector('.cml-feed');
    if(!feed) return;
    var cards = Array.prototype.slice.call(feed.querySelectorAll('.cml-card'));
    var empty = feed.querySelector('.cml-empty');
    var order = cards.slice();
    var state = {filter:'all'};

    function apply(){
      var shown = 0;
      cards.forEach(function(c){
        var ok = true;
        if(state.filter==='photo') ok = c.getAttribute('data-photo')==='1';
        else if(state.filter==='video') ok = c.getAttribute('data-video')==='1';
        else if(state.filter==='whatsapp') ok = c.getAttribute('data-src')==='whatsapp';
        c.style.display = ok ? '' : 'none';
        if(ok) shown++;
      });
      if(empty) empty.hidden = shown>0;
    }
    function sortBy(mode){
      var arr = mode==='helpful'
        ? order.slice().sort(function(a,b){return (+b.getAttribute('data-helpful'))-(+a.getAttribute('data-helpful'));})
        : order.slice();
      arr.forEach(function(c){feed.appendChild(c);});
      if(empty) feed.appendChild(empty);
    }

    root.querySelectorAll('.cml-chip').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('.cml-chip').forEach(function(b){b.setAttribute('aria-pressed','false');});
        btn.setAttribute('aria-pressed','true');
        state.filter = btn.getAttribute('data-filter');
        apply();
      });
    });
    var sel = root.querySelector('.cml-sort');
    if(sel) sel.addEventListener('change',function(){sortBy(sel.value);apply();});
  });
}
cmlInitReviews(document);
document.addEventListener('shopify:section:load', function(e){ cmlInitReviews(e.target); });

  } catch(e) { console.error(e); }
})();
})();
